import svgPaths from './svgs';
import ProprioMark from './ProprioMark';
import React from 'react';

export default function FooterProprioLogo(): React.JSX.Element {
  return (
    <div className="relative size-full" data-name="Vector">
      {/* Full logo - visible above 440px */}
      <div className="hidden min-[440px]:block absolute inset-0" style={{ '--fill-0': 'rgba(33, 33, 33, 1)' } as React.CSSProperties}>
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 154 43">
          <g id="Vector">
            <path d={svgPaths.p859ce80} fill="var(--fill-0, #212121)" />
            <path d={svgPaths.p1edd9080} fill="var(--fill-0, #212121)" />
            <path d={svgPaths.p1fe58be0} fill="var(--fill-0, #212121)" />
            <path d={svgPaths.p372eaa50} fill="var(--fill-0, #212121)" />
            <path d={svgPaths.p3d5eaf0} fill="var(--fill-0, #212121)" />
            <path d={svgPaths.pcde9980} fill="var(--fill-0, #212121)" />
            <path d={svgPaths.p3f2d5800} fill="var(--fill-0, #212121)" />
            <path d={svgPaths.p30dfb600} fill="var(--fill-0, #212121)" />
          </g>
        </svg>
      </div>
      {/* ProprioMark - visible below 440px */}
      <div className="block min-[440px]:hidden absolute inset-0">
        <ProprioMark />
      </div>
    </div>
  );
}
